export const ROWS = 15;
export const COLUMNS = 15;
export const WIDTH = COLUMNS;
export const HEIGHT = ROWS;

export function setCell(grid, x, y, value, { dropOutside }={}) {
  const index = getIndex(x, y);
  const inBounds = x >= 0 && y >= 0 && x < WIDTH && y < HEIGHT;
  if (inBounds) {
    grid[getIndex(x, y)] = value;
    return grid;
  }
  if (!inBounds && !dropOutside) {
    throw(`Not in bounds: ${x}, ${y}`);
  }
  return grid;
}
export function getIndex(x, y) {
  if (x % 1 !== 0 ||y % 1 !== 0) {
    throw(`Not an integer: ${x}, ${y}`)
  }
  return x + (y * WIDTH);
}
export function getCoords(n) {
  const row = Math.floor(n / COLUMNS);
  const column = n % COLUMNS;
  return { x: column, y: row }
}
export function forEachCell(fn) {
  for (let index = 0; index < ROWS * COLUMNS; index++) {
    const {x, y} = getCoords(index);
    fn({index, x, y});
  }
}
export function forEachColumn(fn) {
  for (let index = 0; index < COLUMNS; index++) {
    fn({index, x: index});
  }
}
export function forEachRow(fn) {
  for (let index = 0; index < ROWS; index++) {
    fn({index, y: index});
  }
}
export function createGrid() {
  const grid = [];
  forEachCell(() => {
    grid.push(false);
  });
  return grid;
}
export function getRandomCoords() {
  const x = Math.floor(Math.random() * WIDTH);
  const y = Math.floor(Math.random() * HEIGHT);
  return {x, y};
}

export function minmax(num, min, max){
  const MIN = min || 1;
  const MAX = max || 20;
  const parsed = parseInt(num)
  return Math.min(Math.max(parsed, MIN), MAX)
}


export function drawRect(grid, rectOriginal, {centered, color} = {}) {

  const rect = {...rectOriginal};
  if (centered) {
    rect.x -= Math.floor(rect.width/2);
    rect.y -= Math.floor(rect.height/2);
  }

  const rectBounds = {
    top: rect.y,
    left: rect.x,
    right: rect.x + rect.width - 1,
    bottom: rect.y + rect.height - 1,
  }

  // top
  for (let index = 0; index < rect.width; index++) {
    setCell(grid, rectBounds.left + index, rectBounds.top, color || true, { dropOutside: true });
  }

  // right
  for (let index = 0; index < rect.height; index++) {
    setCell(grid, rectBounds.right, rectBounds.top + index, color || true, { dropOutside: true });
  }

  // bottom
  for (let index = 0; index < rect.width; index++) {
    setCell(grid, rectBounds.left + index, rectBounds.bottom, color || true, { dropOutside: true });
  }

  // left
  for (let index = 0; index < rect.height; index++) {
    setCell(grid, rectBounds.left, rectBounds.top + index, color || true, { dropOutside: true });
  }

}